(ns frontend.view.modals.new-kpi-cycle.view
  (:require
   [common.localization :as loc]
   [common.util :as cu :refer [flip]]
   [common.entity :as entity]
   [clojure.string :as string]
   [frontend.utils :as utils]
   [frontend.view.modals.new-kpi-cycle.events :as events]
   [frontend.view.modals.confirmation.view :as confirmation-modal]
   [frontend.view.modals.events :as modals]
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [frontend.utils :as fu]
   [ui.color :as c]
   [ui.components.alert.view :as alert]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.components.radio-group.view :as radio-group]
   [ui.components.button.view :as button]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.loading-spinner.view :as loading-spinner]))

(defonce modal-key :new-kpi-cycle-modal)

(defn change-email-option!
  [state val]
  (swap! state assoc :email-option val))

(defn their-contact-str
  [kw contact]
  (let [{:keys [account/first-name account/last-name]} contact
        kw (or kw :first-name)]
    (case kw
      :first-name (str " " first-name)
      :last-name (str " " last-name)
      :full-name (str " " first-name " " last-name)
      "")))

(defn our-contact-str
  [kw contact]
  (let [{:keys [account/first-name account/last-name]} contact
        kw (or kw :first-name)]
    (case kw
      :first-name (str "\n" first-name)
      :last-name (str "\n" last-name)
      :full-name (str "\n" first-name " " last-name)
      "")))


(defn target-month-input
  [{:keys [edit-state value]}]
  (let [options (->> (range 1 13)
                     (map (fn [n]
                            {:value   n
                             :label (str n)})))
        attribute :kpi-cycle/target-month]
    [:div
     {:class "w-28"}
     [labelled-input/view
      {:editor-type :editor.type/select
       :options     options
       :value       (->> options
                         (cu/filter-by :value value)
                         (first))
       :placeholder        (loc/tr :month)
       :label              (loc/tr :month)
       :on-change   (fn [new-value]
                      (if (nil? new-value)
                        (swap! edit-state dissoc attribute new-value)
                        (swap! edit-state assoc attribute new-value)))}]]))

(defn target-year-input
  [{:keys [edit-state value year-options]}]
  (let [options (->> year-options
                     (map (fn [n]
                            {:value   n
                             :label (str n)})))
        attribute :kpi-cycle/target-year]
    [:div
     {:class "w-28"}
     [labelled-input/view
      {:editor-type :editor.type/select
       :options     options
       :value       (->> options
                         (cu/filter-by :value value)
                         (first))
       :placeholder        (loc/tr :year)
       :label              (loc/tr :year)
       :on-change   (fn [new-value]
                      (if (nil? new-value)
                        (swap! edit-state dissoc attribute new-value)
                        (swap! edit-state assoc attribute new-value)))}]]))

(defn confirm
  [{:keys [state attribute]}]
  [checkbox/view
   {:value     (boolean (get @state attribute))
    :on-change #(swap! state update-in [attribute] not)}])

(defn members-view
  [{:keys [state members]}]
  [:div
   {:class "flex flex-col gap-3"}
   [:div
    {:class "text-md font-bold leading-4"}
    (loc/tr :kpi-cycle/select-companies)]
   [:div
    {:class "border border-solid border-base-light-border-paler rounded-lg overflow-x-auto"}
    [:table
     {:class "w-full divide-y divide-solid divide-base-light-border-paler"}
     [:thead
      [:tr
        {:class "*:whitespace-nowrap *:px-3 *:py-3 *:text-sm *:text-base-light-text even:bg-base-regular"}
       [:th
         {:class "w-8"}
        ""]
       [:th (loc/tr :kpi-company)]
       [:th (loc/tr :their-contact)]
       [:th (loc/tr :our-contact)]]]
     [:tbody
      {:class "divide-y divide-solid divide-base-light-border-paler"}
      (doall
       (for [member members
             :let [company (->> member
                                :kpi-member/asset
                                (get @session/entities))
                   owner (->> member
                              :common/owner
                              (get @session/entities))
                   contact (->> member
                                :kpi-member/account
                                (get @session/entities))]]
         ^{:key (:db/id member)}
         [:tr
           {:class    "*:px-3 *:py-3 *:whitespace-nowrap *:text-sm *:text-base-light-text *:align-middle *:leading-3"}
          [:td
           {:class "w-8"}
           [confirm
            {:state     state
             :attribute (:db/id member)}]]
          [:td [:span (entity/display-string company)]]
          [:td [:span (entity/display-string contact)]]
          [:td [:span (entity/display-string owner)]]]))]]]])

(defn error-view
  []
  [alert/danger
   {}
   [:div
    [:strong (loc/tr :new-cycle-modal/report-cycle-error)]
    [:a {:href (str "mailto:" (loc/tr :support-email-address))}
     (loc/tr :support-email-address)]]])

(defn ready-view
  []
  [:div
   {:class "py-4 flex flex-col items-center gap-6 text-bold"}
   [:img
    {:src "/img/ecosystem-sent-success.svg"
     :class "max-w-32 h-auto"}]
   (loc/tr :new-cycle-modal/report-cycle-done)])

(defn view
  [{:keys [shown? close-modal! props state topmost?]}]
  (let [edit-state (r/cursor state [:edit])
        confirm-state (r/cursor state [:confirm])
        entity-atom (r/cursor state [:entity-atom])
        state-atom (r/cursor state [:state-atom])
        {:keys [category]} props
        category-id (:db/id category)
        members (->> @session/all-kpi-members
                     (cu/only-entity :kpi-member/target category-id)
                     (remove :common/disabled?))]
    (events/reset-state! state members)
    (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
      (let [{:keys [category]} props
            {:keys [alert processing? ready? error?]} @state
            now (js/Date.)
            current-year (.getFullYear now)
            year-options (->> (range (- current-year 7) (+ current-year 2))
                              reverse)
            cycle @edit-state
            {:keys [kpi-cycle/target-month kpi-cycle/target-year]} cycle
            category-id (:db/id category)
            category-name (:kpi-category/name category)

            email-option (or (:email-option @state)
                             :now)
            members (->> @session/all-kpi-members
                         (cu/only-entity :kpi-member/target category-id)
                         (remove :common/disabled?))
            cycles (->> @session/all-kpi-cycles
                        (cu/only-entity :kpi-cycle/kpi-category category-id)
                        (remove :common/disabled?))
            ;;use latest cycle to get latest values for members
            ;; (report with matching [:kpi-report/cycle :kpi-report/company]
            ;;  => take :common/owner and :kpi-report/contact-account (:kpi-report/contact-person not needed?))
            latest-cycle (->> cycles
                              (sort-by (juxt :kpi-cycle/target-year :kpi-report/target-month))
                              last)
            cycle-exists? (->> cycles
                               (cu/only-entity :kpi-cycle/target-month target-month)
                               (cu/only-entity :kpi-cycle/target-year target-year)
                               empty?
                               not)
            button-disabled? (or cycle-exists?
                                 (string/blank? target-month)
                                 (string/blank? target-year))

            options (->> [:kpi-cycle/send-email-now :kpi-cycle/send-email-later]
                         (map (fn [p]
                                {:value   p
                                 :content (loc/tr p)})))]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :create-kpi-cycle)
         (if processing?
           [:div
            {:class "flex flex-col gap-4 justify-center items-center"}
            [:div
             {:class "*:w-12 *:h-12"}
             [loading-spinner/circle
              {:size :4xl}]]
            [:span
             (loc/tr :new-cycle-modal/processing-info)]]
           [:<>
            (cond
              error?
              [error-view]
              ready?
              [ready-view]
              :else
              [:div
               {:class "flex flex-col gap-6"}
               (when alert
                  [alert/danger
                   {:on-close    (partial events/hide-alert! state)}
                   alert])
                (when cycle-exists?
                 [alert/danger
                  {}
                  [:strong (loc/tr :this-cycle-exists [category-name])]])
               [:div
                {:class "flex flex-col gap-3"}
                [:div
                 {:class "text-md font-bold leading-4"}
                 (loc/tr :kpi-cycle/select-target-period)]
                [:div
                 {:class "flex gap-2"}
                 [:div
                  [target-month-input
                   {:edit-state edit-state
                    :state-atom state-atom
                    :value      target-month}]]
                 [:div
                  [target-year-input
                   {:edit-state   edit-state
                    :state-atom   state-atom
                    :value        target-year
                    :year-options year-options}]]]]


               [members-view
                {:members members
                 :state   confirm-state}]])

            (when-not (or ready? error?)
              [:div
               {:class "pt-6 inline-flex items-start flex-col gap-4"}
               [radio-group/radio-group-v2
                {:checked   (:role-kw @state)
                 :orientation :vertical
                 :on-change (fn [value]
                              (swap! state assoc :role-kw value))}
                options]

               [button/secondary-hollow
                {:on-click
                 (fn [e]
                   (.preventDefault e)
                   (.stopPropagation e)
                   (modals/open-modal!
                    confirmation-modal/modal-key
                    {:body           (let [email-title (:kpi-category/email-title category)
                                           email-greeting (:kpi-category/email-greeting category)
                                           email-greeting-contact (:kpi-category/email-greeting-contact
                                                                   category)
                                           their-contact {:account/first-name "John"
                                                          :account/last-name  "Smith"}
                                           email-greeting-contact-str
                                           (their-contact-str email-greeting-contact their-contact)
                                           full-greeting (str email-greeting email-greeting-contact-str)
                                           email-copy (:kpi-category/email-copy category)
                                           email-ending (:kpi-category/email-ending category)
                                           email-ending-contact (:kpi-category/email-ending-contact category)
                                           our-contact {:account/first-name "James"
                                                        :account/last-name  "Bond"}
                                           email-ending-contact-str (our-contact-str email-ending-contact
                                                                                     our-contact)
                                           full-ending (str email-ending email-ending-contact-str)
                                           ending-note-1 (loc/tr :email-template-ending-note-1
                                                             ["James Bond" "Demo Ventures"])
                                           ending-note-2 (loc/tr :email-template-ending-note-2 ["Demo Ventures"])
                                           reporting-email "reporting@zapflow.com"
                                           full-email (str ""
                                                           (when-not (empty? full-greeting)
                                                             (str full-greeting ",\n\n"))
                                                           email-copy
                                                           "\n\n"
                                                           full-ending)]
                                       [:div
                                        {:class "flex flex-col gap-3"}
                                        [:div
                                         {:class "mb-0 inline-grid grid-cols-10 gap-4 text-sm"}
                                         [:span
                                          {:class "col-span-1 text-base-light-text-paler font-normal"}
                                          (loc/tr :email/from) ":"] " "
                                         [:span
                                          {:class "col-span-9"}
                                          "reporting@zapflow.com"]]
                                        [:div
                                         {:class "mb-0 inline-grid grid-cols-10 gap-4 text-sm"}
                                         [:span
                                           {:class "col-span-1 text-base-light-text-paler font-normal"}
                                          (loc/tr :email/to) ":"] " "
                                         [:span
                                          {:class "col-span-9"}
                                          "john.smith@targetcompany.com"]]
                                        [:div
                                         {:class "mb-0 inline-grid grid-cols-10 gap-4 text-sm"}
                                         [:span
                                           {:class "col-span-1 text-base-light-text-paler font-normal"}
                                          (loc/tr :sub) ":"] " "
                                         [:span
                                          {:class "col-span-9"}
                                          email-title]]

                                        [:div
                                         {:class "pt-4 whitespace-pre-wrap font-normal"}
                                         full-email
                                         "\n\n"
                                         [:span
                                          {:class "block text-xs text-base-light-text-paler"}
                                          ending-note-1
                                          [:a
                                           {:href (str "mailto:" reporting-email)}
                                           reporting-email]
                                          ending-note-2]]])
                     :body-class     ""
                     :confirm-text   (loc/tr :ok)
                     :confirm-color  ::c/primary
                     :confirm-icon   ""
                     :title          (loc/tr :preview)
                     :skip-checkbox? true
                     :hide-cancel?   true
                     :on-confirm     identity}))}
                (loc/tr :preview-request)]])])
         (cond
           processing?
           nil
           error?
           [modal/right-single-button
            nil
            false
            (partial events/back! state)
            (loc/tr :back)
            nil]
           ready?
           [modal/right-single-button
            nil
            false
            close-modal!
            (loc/tr :continue)
            nil]
           :else
           [modal/right-single-button
            nil
            (boolean button-disabled?)
            #(events/create-cycle! state category close-modal!)
            (loc/tr :create-kpi-cycle)
            nil])]))))
